import { render, staticRenderFns } from "./PostStub.vue?vue&type=template&id=a8f3425c&scoped=true&"
import script from "./PostStub.vue?vue&type=script&lang=js&"
export * from "./PostStub.vue?vue&type=script&lang=js&"
import style0 from "./PostStub.vue?vue&type=style&index=0&id=a8f3425c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f3425c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VChip,VIcon,VSpacer})
